import { Component } from 'react';

interface ColorLegendButtonProps {
    onClick: () => void;
    isDisabled?: boolean;
    customTooltip?: string;
}

interface ColorLegendButtonState {}

export class ColorLegendButton extends Component<ColorLegendButtonProps, ColorLegendButtonState> {
    render() {
        return <div />;
    }
}
